import type { MerchantResponse } from '@repo/api/endpoints/merchant';
import {
  MIN_LOAN_AMOUNT,
  LIBERIS_MAX_LOAN_AMOUNT,
  PRAGMA_MAX_LOAN_AMOUNT,
} from '@repo/shared/constants';
import { providerType, ProviderType } from '@repo/shared/types';
import {
  getMaxAvailableAmountAndCurrency,
  getMinAvailableAmountAndCurrency,
} from '@repo/store/helpers';

export const getMinMaxLoanAmount = (
  merchantResponseData?: MerchantResponse,
  provider?: ProviderType,
) => {
  if (provider === providerType.enum.liberis) {
    const liberisMaxAmount = getMaxAvailableAmountAndCurrency(
      merchantResponseData,
      providerType.enum.liberis,
    );

    const liberisMinAmount = getMinAvailableAmountAndCurrency(
      merchantResponseData,
      providerType.enum.liberis,
    );

    return {
      min:
        typeof liberisMinAmount === 'undefined' || liberisMinAmount.min < MIN_LOAN_AMOUNT
          ? MIN_LOAN_AMOUNT
          : liberisMinAmount.min,
      max: typeof liberisMaxAmount === 'undefined' ? LIBERIS_MAX_LOAN_AMOUNT : liberisMaxAmount.max,
    };
  }

  const pragmaMaxAmount = getMaxAvailableAmountAndCurrency(
    merchantResponseData,
    providerType.enum.pragma,
  );

  return {
    min: MIN_LOAN_AMOUNT,
    max: typeof pragmaMaxAmount === 'undefined' ? PRAGMA_MAX_LOAN_AMOUNT : pragmaMaxAmount.max,
  };
};
